/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

import Package from '../../package.json'

/**
 *  getVersion - Get version from package.json
 */
export const getVersion = () => {
    return Package.version
}

/**
 *  getPackageNameName - Get version from package.json
 */
export const getPackageNameName = () => {
    return Package.name
}
